import { render, staticRenderFns } from "./Jgdt.vue?vue&type=template&id=39425201&scoped=true&"
import script from "./Jgdt.vue?vue&type=script&lang=js&"
export * from "./Jgdt.vue?vue&type=script&lang=js&"
import style0 from "./Jgdt.vue?vue&type=style&index=0&id=39425201&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39425201",
  null
  
)

export default component.exports